export const data1 = [
  ['Cat A', 4],
  ['Cat B', 3],
  ['Cat C', 32],
  ['Cat D', 190],
  ['Cat E', 754],
];
